import { render } from "./Gameboard_2.vue?vue&type=template&id=4351e60f"
import script from "./Gameboard_2.vue?vue&type=script&lang=js"
export * from "./Gameboard_2.vue?vue&type=script&lang=js"

import "./Gameboard_2.vue?vue&type=style&index=0&id=4351e60f&lang=scss"
script.render = render

export default script